import React from "react";
import { Link } from "react-router-dom";
import { getBreadcrumbSchema } from "./schemaTemplates";
import "./Breadcrumbs.css";

/**
 * Accessible Breadcrumb Component
 * Injects Google-compliant BreadcrumbList Schema.org microdata and visual navigation trail
 */
export default function Breadcrumbs({ items = [] }) {
  if (!items || items.length === 0) return null;

  const schema = getBreadcrumbSchema(items);

  return (
    <div className="breadcrumb-wrapper">
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>

      <nav aria-label="Breadcrumb" className="breadcrumb-nav">
        <ol className="breadcrumb-list" itemScope itemType="https://schema.org/BreadcrumbList">
          <li className="breadcrumb-item" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            <Link to="/" itemProp="item" className="breadcrumb-link">
              <span itemProp="name">Home</span>
            </Link>
            <meta itemProp="position" content="1" />
            <span className="breadcrumb-separator" aria-hidden="true">/</span>
          </li>

          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            const position = index + 2;

            return (
              <li 
                key={item.url || index} 
                className={`breadcrumb-item ${isLast ? "active" : ""}`}
                itemProp="itemListElement" 
                itemScope 
                itemType="https://schema.org/ListItem"
              >
                {isLast ? (
                  <span itemProp="name" aria-current="page" className="breadcrumb-current">
                    {item.name}
                  </span>
                ) : (
                  <>
                    <Link to={item.url} itemProp="item" className="breadcrumb-link">
                      <span itemProp="name">{item.name}</span>
                    </Link>
                    <span className="breadcrumb-separator" aria-hidden="true">/</span>
                  </>
                )}
                <meta itemProp="position" content={position.toString()} />
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
}
